import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmGeneralInfo } from '~/api/repository'
import { generalKey } from '~/api/service/query-keys.const'
import { generalParamType } from '~/types/general.type'

export const useFetchGeneral = (types: generalParamType[], intervalTime?: number) => {
  return useQuery([ ...generalKey, ...types ], (): Promise<ViewGeneralInfo> => {
    return explorerApi.generalController.getHomeGeneral ({ 
      requestBody: {
        types
      }
    }).then((res) => {
      return generalDto(res as EvmGeneralInfo)
    })
  }, { refetchInterval: intervalTime || false })
}

export type ViewGeneralInfo = EvmGeneralInfo

const generalDto = (info: EvmGeneralInfo): ViewGeneralInfo => {
  return {
    ...info,
  }
}